import {fetchAllRows} from '../exports/exportUtils';
import {tripPayload, tripTotals} from './travelCalculations';
export {calculateFuelCost} from './travelCalculations';
import {supabase} from '../supabase/client';

export const VEHICLES_TABLE = 'vehicles_1772928700000';
export const TRIPS_TABLE = 'trips_1772928700000';
export const ODOMETER_TABLE = 'odometer_readings_1772928700000';

export async function listVehicles(businessId) {
  const {data, error} = await supabase
    .from(VEHICLES_TABLE)
    .select('*')
    .eq('business_id', businessId)
    .eq('is_active', true)
    .order('name');

  if (error) throw error;
  return data || [];
}

export async function createVehicle(userId, businessId, values) {
  const {data, error} = await supabase
    .from(VEHICLES_TABLE)
    .insert({
      user_id: userId,
      business_id: businessId,
      name: values.name.trim(),
      license_plate: values.licensePlate?.trim() || null,
      year: values.year ? Number(values.year) : null,
      make: values.make?.trim() || null,
      model: values.model?.trim() || null,
      fuel_type: values.fuelType,
      fuel_consumption_l_per_100km: values.fuelConsumption
        ? Number(values.fuelConsumption)
        : null,
      opening_odometer_km: Number(values.openingOdometer),
      current_odometer_km: Number(values.currentOdometer)
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function archiveVehicle(vehicleId, userId, businessId) {
  const {error} = await supabase
    .from(VEHICLES_TABLE)
    .update({is_active: false})
    .eq('id', vehicleId)
    .eq('user_id', userId)
    .eq('business_id', businessId);

  if (error) throw error;
}

export async function listTrips(businessId, filters = {}) {
  return fetchAllRows(() => {
  let query = supabase
    .from(TRIPS_TABLE)
    .select('*, vehicles_1772928700000(name,fuel_type,fuel_consumption_l_per_100km)')
    .eq('business_id', businessId)
    .order('trip_date', {ascending: false})
    .order('created_at', {ascending: false});

  if (filters.from) query = query.gte('trip_date', filters.from);
  if (filters.to) query = query.lte('trip_date', filters.to);
  if (filters.vehicleId) query = query.eq('vehicle_id', filters.vehicleId);

  return query;
  });
}

export async function getMonthlyTripSummary(businessId, from, to) {
  const trips = await listTrips(businessId, {from, to});

  return {
    trips,
    count: trips.length,
    distance: tripTotals(trips).businessDistance,
    recordedDistance: tripTotals(trips).recordedDistance
  };
}

export async function createTrip(userId, businessId, values, client = supabase) {
  if (!values.submissionId) throw new Error('A trip request ID is required.');
  const {data, error} = await client.rpc('create_trip_once', {
    p_request_id: values.submissionId, p_business_id: businessId, p_trip: tripPayload(values)
  });
  if (error) throw error;
  return data;
}

export async function deleteTrip(tripId, userId, businessId) {
  const {error} = await supabase
    .from(TRIPS_TABLE)
    .delete()
    .eq('id', tripId)
    .eq('user_id', userId)
    .eq('business_id', businessId);

  if (error) throw error;
}

export function getMonthRange(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');

  return {
    from: `${year}-${month}-01`,
    to: `${year}-${month}-${String(new Date(year, date.getMonth() + 1, 0).getDate()).padStart(2, '0')}`
  };
}